import {IAugmentedJQuery, IComponentOptions, IController, IScope} from 'angular';
import {GmcTabSetController} from '../../gmc-tabs-set.component';

export class GmcTabController implements IController {
  static $inject = ['$scope', '$element'];
  public gmcTabSetCtrl: GmcTabSetController;
  public tabName: string;
  public isActive: boolean;
  onSelect: () => void;

  constructor(private $scope: IScope,
              private element: IAugmentedJQuery) {

  }

  public $onInit() {
    this.gmcTabSetCtrl.addTab(this);
    this.$scope.$watch('$ctrl.isActive', (val) => {
      this.element.css('display', val ? 'block' : 'none');
      if (val) {
        this.onSelect();
      }
    });
  }

  public $onDestroy() {
    this.gmcTabSetCtrl.removeTab(this);
  }
}

export const GmcTabComponent: IComponentOptions = {
  controller: GmcTabController,
  template: require('./gmc-tab.component.html'),
  require: {
    gmcTabSetCtrl: '^gmcTabSet'
  },
  transclude: {
    tabHeader: '?gmcTabHeader'
  },
  bindings: {
    tabName: '@',
    tabAdditionalName: '@',
    onSelect: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-tabs/components/gmc-tab/gmc-tab.component.ts